import React from 'react'
import {FaInfoCircle} from 'react-icons/fa'
import Notice from '@components/V3/Notice'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

export default function DelayWarning() {
  const {t} = useTranslation('tracking', {keyPrefix: 'delayWarning'})
  const {order} = useOrder()

  if (order.isScheduled) return null
  if (order.orderStatus !== 'pending') return null
  if (!order.store.hasDelayInAcceptingOrders) return null

  return (
    <Notice level="info" className="mt-6">
      <div className="flex items-center space-x-4">
        <FaInfoCircle size={18} />
        <div className="flex-1">{t('warning')}</div>
      </div>
    </Notice>
  )
}
